/**
 * Keep-alive utility for maintaining LiveKit connection
 * Prevents the browser from closing the connection when tab is inactive
 */

class KeepAlive {
  constructor() {
    this.intervalId = null;
    this.isActive = false;
  }

  /**
   * Start keep-alive pings
   */
  start(room) {
    if (this.isActive) {
      console.log('Keep-alive already active');
      return;
    }

    console.log('🔄 Starting keep-alive...');
    this.isActive = true;

    // Send periodic keep-alive messages (every 25 seconds)
    this.intervalId = setInterval(() => {
      if (room && room.state === 'connected') {
        console.log('💓 Keep-alive ping');
        // Send a small data packet to keep connection alive
        try {
          room.localParticipant.publishData(
            new TextEncoder().encode(JSON.stringify({ type: 'keepalive', timestamp: Date.now() })),
            { reliable: false, topic: 'keepalive' }
          );
        } catch (error) {
          console.warn('Keep-alive ping failed:', error);
        }
      }
    }, 25000); // Every 25 seconds
  }

  /**
   * Stop keep-alive pings
   */
  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.isActive = false;
      console.log('🔄 Keep-alive stopped');
    }
  }
}

export default new KeepAlive();




